const ServiceIdentifier = {
  ConfiguratorService: Symbol('ConfiguratorService'),
};

export default ServiceIdentifier;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/services/serviceIdentifiers.ts